import DonateFormAddressPopoutForm from 'javascripts/components/DonateForm/AddressPopoutForm';
import DonateFormButton from 'javascripts/components/DonateForm/Button';
import DonateFormDonorInfoPopoutForm from 'javascripts/components/DonateForm/DonorInfoPopoutForm';
import React from 'react';
import cx from 'classnames';
import store from 'javascripts/store';
import {CardElement, injectStripe} from 'react-stripe-elements';
import {observer} from 'mobx-react';

@observer
class StripeElements extends React.Component {
  static cardValidationErrorMessages = {
    empty: "YOUR CARD'S INFORMATION IS INCOMPLETE",
  }

  componentDidMount() {
    store.donateForm.cardElementCompleted = false;
    store.donateForm.cardElementStep1Error = '';
    store.donateForm.creditCardStep = 1;
    store.donateForm.submitHandler = this.handleClick;
  }

  handleCardElementChange = (event) => {
    store.donateForm.cardElementStep1Error = '';
    if (event.error) store.donateForm.cardElementStep1Error = event.error.message.replace('.', '');

    store.donateForm.cardElementCompleted = event.complete;
  }

  handleClick = (event) => {
    event.preventDefault();
    if(!store.donateForm.cardElementCompleted) { store.donateForm.cardElementStep1Error = StripeElements.cardValidationErrorMessages.empty; }
    if(!this.props.validateForm() || !store.donateForm.cardElementCompleted) { return false; }

    store.donateForm.creditCardStep === 1 ? this.handleNextStep() : this.handlePayment();
  }

  handleNextStep = () => {
    if(store.donateForm.isSubscription) {
      $.getJSON(`/api/v1/spring_membership/${store.donateForm.email}`, (data) => {
        store.donateForm.isAlreadySpringMember = data['is_spring_member'];
        store.donateForm.existingMembershipCountry = data['existing_membership_country'];
        store.donateForm.disableFormSubmit = true;
        store.donateForm.createSetupIntent(() => {
          store.donateForm.creditCardStep = 2;
          store.donateForm.disableFormSubmit = false;
        });
      });
    } else {
      store.donateForm.disableFormSubmit = true;
      store.donateForm.createOrUpdatePaymentIntent(() => {
        store.donateForm.creditCardStep = 2;
        store.donateForm.disableFormSubmit = false;
      });
    }
  }

  handlePrevStep = () => {
    store.donateForm.creditCardStep = 1;
  }

  handlePayment = () => {
    store.donateForm.disableFormSubmit = true;

    this.props.trackPayButtonClick({
      button_type: 'Credit Card',
    });

    window.Rollbar.info('Stripe Donate Form Submitted', { formData: store.donateForm.donationFormParams });

    if(store.donateForm.isSubscription) {
      store.donateForm.createOrUpdateDonationForm('stripe', ({redirectUrl}) => {
        this.props.stripe.handleCardSetup(
          store.donateForm.setupIntentSecret,
          store.donateForm.paymentMethodData,
        ).then((response) => {
          if(response.error) {
            store.donateForm.handleCardError(response.error.message);
          } else {
            if(store.bps.hasRecipients && !store.donateForm.managementMode) {
              store.bps.paymentMethod = 'stripe';
              return;
            }
            window.location = redirectUrl;
          }
        });
      }, ({error}) => {
        store.donateForm.handleCardError(error);
      });
    } else {
      store.donateForm.createOrUpdateDonationForm('stripe', ({redirectUrl}) => {
        this.props.stripe.handleCardPayment(
          store.donateForm.paymentIntentSecret,
          store.donateForm.paymentMethodData,
        ).then((response) => {
          if(response.error) {
            store.donateForm.handleCardError(response.error.message);
          } else {
            window.location = redirectUrl;
          }
        });
      }, ({error}) => {
        store.donateForm.handleCardError(error);
      });
    }
  }

  isStripe = () => store.donateForm.paymentTab === 'stripe';
  isStripeAndStep = step => this.isStripe() && step == store.donateForm.creditCardStep;

  hideCardElement = () => (
    !this.isStripeAndStep(1) || store.donateForm.showSpringMembershipAlreadyExistsMessage
  )

  render() {
    const cardElementStyles = {
      base: {
        color: '#333232',
        fontFamily: 'Proxima Nova, Helvetica Neue, Helvetica, Arial, sans-serif',
        fontSize: '16px',
        fontSmoothing: 'antialiased',
        height: '48px',
        iconColor: '#71716c',
        '::placeholder': {
          color: '#c1c1ba',
        },
      },
      invalid: {
        color: '#fa575d',
        iconColor: '#fa575d',
      },
    };

    const cardElementClassOverrides = {
      invalid: 'error',
    };

    const buttonText = store.donateForm.creditCardStep === 1 ? 'Next Step' : store.donateForm.donateButtonText;

    return(
      <div className='_form-wrapper mt-2'>
        {this.isStripeAndStep(1) && !store.donateForm.showSpringMembershipAlreadyExistsMessage &&
          <DonateFormDonorInfoPopoutForm
            namePlaceholder='First Name'
            surnamePlaceholder='Last Name'
          />
        }

        <CardElement
          classes={cardElementClassOverrides}
          className={cx('rounded card-element-input-padding border border-solid border-grey-40 display-none-in-percy', {'error': !!store.donateForm.cardElementStep1Error, 'hidden': this.hideCardElement()})}
          hidePostalCode={true}
          onChange={this.handleCardElementChange}
          style={cardElementStyles}
        />

        { !store.donateForm.showSpringMembershipAlreadyExistsMessage &&
          <>
            {this.isStripeAndStep(1) &&
              <ul className='parsley-errors-list'>
                <li>
                  {store.donateForm.cardElementStep1Error}
                </li>
              </ul>
            }

            {this.isStripeAndStep(2) &&
              <>
                <div
                  className='edit-details-button'
                  onClick={this.handlePrevStep}
                >
                  <span className='h80'>Edit card details</span>
                </div>

                <DonateFormAddressPopoutForm />
              </>
            }

            {this.isStripe() &&
              <>
                <DonateFormButton
                  onClick={this.handleClick}
                  text={buttonText}
                />
              </>
            }
          </>
        }
      </div>
    );
  }
}

export default injectStripe(StripeElements, {withRef: true});
